import type { Calculation } from "@suse-o11y/calculate-value-from-points";
import { ImmutableSet } from "@suse-o11y/immutable-set";

const ALL_POSITIONS = ["bottom", "right"] as const;

type Position = (typeof ALL_POSITIONS)[number];

const ALL_MODES = ["list", "table"] as const;

type Mode = (typeof ALL_MODES)[number];

type Columns = ImmutableSet<Calculation>;

interface Settings {
	show?: boolean;
	position?: Position;
	mode?: Mode;
	columns?: Columns;
}

const DEFAULT = {
	show: true,
	position: "bottom",
	mode: "list",
	columns: ImmutableSet.empty,
} satisfies Settings;

export type { Columns, Mode, Position, Settings };
export { ALL_MODES, ALL_POSITIONS, DEFAULT };
